// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import { ModalHandlersContext, ModalPropsContext } from './../../context'

import { XIcon } from 'components/shared/Icon/Icon'

import styles from './Header.module.scss'

export const Header = ({ className = undefined }) => {
  const { onClose } = React.useContext(ModalHandlersContext)
  const { title } = React.useContext(ModalPropsContext)

  return (
    <header className={cx(styles.header, { [className]: Boolean(className) })}>
      {title ? <h2 className={styles.title}>{title}</h2> : null}
      <Button
        ariaLabel="close"
        className={styles.button}
        icon={XIcon}
        size="small"
        variant="text"
        onClick={onClose}
      />
    </header>
  )
}
